import { useMutation } from "@apollo/client";
// import moment from "moment";
import { useForm } from "react-hook-form";
import { CREATE_QUOTATION } from "../apollo/mutations";
import {
  getSelectedStoreDetails,
  payloadValidator,
} from "../utils/helperFunctions";
import { showErrorToast } from "../utils";
import closeModal from "../common/closeModal";
import { useEffect } from "react";
import dayjs from "dayjs";
import "react-datepicker/dist/react-datepicker.css";

const defaultValues = {
  customer_id: "",
  warehouse_id: "",
  quotation_date: dayjs(),
  status: "Pending",
  order_tax: "0",
  discount: "0",
  shipping: "0",
};

const useCreateQuotation = (productArray, refetch) => {
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ defaultValues });

  const [submit, { loading }] = useMutation(CREATE_QUOTATION);

  useEffect(() => {
    if (!watch("quotation_date")) {
      setValue("quotation_date", dayjs().toDate());
    }
  }, [setValue, watch]);

  const onAddQuotation = async (data) => {
    try {
      if (productArray?.length > 0) {
        const invalidProduct = productArray.find(
          (item) =>
            item.price == "" || item.price == "0" || item.price === undefined
        );

        if (invalidProduct) {
          showErrorToast("Please enter a valid product price");
          return;
        }

        const invalidQty = productArray.find(
          (item) =>
            item.quantity == "" ||
            item.quantity == "0" ||
            item.quantity === undefined
        );

        if (invalidQty) {
          showErrorToast("Please enter a valid product quantity");
          return;
        }

        const quotationDate = dayjs(data?.quotation_date);
        if (!quotationDate.isValid()) {
          showErrorToast("Invalid Date Selected");
          return;
        }
        let payload = {
          customer_id: data?.customer_id,
          store_id: getSelectedStoreDetails("id"),
          warehouse_id: data?.warehouse_id,
          quotation_date: quotationDate.format("MM-DD-YYYY"),
          status: data?.status,
          order_tax: parseFloat(data?.order_tax),
          discount: parseFloat(data?.discount),
          shipping: parseFloat(data?.shipping),
          description: null,
          order_products: productArray?.map((item) => ({
            product_id: parseInt(item?.product_id),
            quantity: parseInt(item?.quantity),
            price: parseFloat(item?.price),
          })),
        };
        console.log("payload", payload);
        console.log("productArray", productArray);
        await submit(payloadValidator(payload));
        reset(defaultValues);
        refetch();
        closeModal("add-units");
      } else {
        showErrorToast("Please Add Product");
      }
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
    closeModal("add-units");
  };

  return {
    values: {
      control,
      errors,
      setValue,
      getValues,
      loading,
    },
    functions: {
      onSubmit: handleSubmit(onAddQuotation),
      onCancel,
    },
  };
};

export default useCreateQuotation;
